define('drops/documentPreviewer/documentPreviewer',[
    'jquery',
    'lq',
    'lq/drop',
    'lq/style'
], function ($, lq, Drop, Style) {
    'use strict';

    var filenameEndsWith = function(filename, suffixes) {
        return _.some(suffixes, function (suffix) {
            return filename.toLowerCase().indexOf(suffix, filename.length - suffix.length) !== -1;
        });
    };

    function DocumentPreviewer(options) {
        Drop.call(this, $('<div/>'), options);
        Style.renderStyles(this);
    }

    Drop.extend(DocumentPreviewer, Drop);

    DocumentPreviewer.typeName = 'DocumentPreviewer';

    DocumentPreviewer.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    DocumentPreviewer.prototype.setValue = function (update) {
        var documentUrl = update.value.url || update.value.Url;

        this.$element.empty();

        if (this.isImage(documentUrl)) {
            this.$element
                .append($('<img src="' + this.getFullDocumentUrl(documentUrl) + '" />')
                    .css({
                        'display': 'block',
                        'max-width': '100%',
                        'max-height': '100%',
                        'width': 'auto',
                        'height': 'auto',
                        'margin': '0 auto'
                    }));
        } else {
            var url = this.getEmbeddedUrl(documentUrl);

            this.$element
                .append($('<iframe src="' + url + '" width="100%" height="100%" frameborder="0" />'));
        }
    };

    DocumentPreviewer.prototype.clearValue = function () {
        this.$element.empty();
    };

    DocumentPreviewer.prototype.getEmbeddedUrl = function (documentUrl) {
        var fullDocumentUrl = this.getFullDocumentUrl(documentUrl);

        if (this.isOfficeFile(documentUrl))
            return 'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fullDocumentUrl);

        if (this.isPdfFile(documentUrl))
            return lq.getCdnUrl('drops/DocumentPreviewer/view/viewer.html?file=' + encodeURIComponent(fullDocumentUrl));

        return 'https://docs.google.com/viewer?url=' + encodeURIComponent(fullDocumentUrl) + '&embedded=true';
    };

    DocumentPreviewer.prototype.getFullDocumentUrl = function (documentUrl) {
        return lq.getFullUrl(lq.getTenantUrl('DynamicContent/DownloadFile?url=' + documentUrl + '&openInBrowser=true'));
    };

    DocumentPreviewer.prototype.isPdfFile = function (filename) {
        return filenameEndsWith(filename, ['.pdf']);
    };

    DocumentPreviewer.prototype.isOfficeFile = function (filename) {
        return filenameEndsWith(filename, ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx']);
    };

    DocumentPreviewer.prototype.isImage = function (filename) {
        return filenameEndsWith(filename, ['.bmp', '.jpg', '.jpeg', '.png', '.gif']);
    };

    return DocumentPreviewer;
});
